<template>
    <el-form ref="form" :model="form" class="box-set" label-width="160px">
        <el-card header="设置规则名称" shadow="naver">
            <el-form-item label="发货类型">
              <el-radio-group v-model="form.sale_type" @change="saleTypeChange">
                <el-radio label="0" value="0" >按天数</el-radio>
                <el-radio label="1" value="1">按日期</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item class="content-left" v-if="form.sale_type==0" label="预计几天后开始发货" prop="shipdays" :rules="[{ required: true, message: '请输入商品预计发货时间', trigger: 'blur' }]">
              <el-input placeholder="请输入商品预计几天后开始发货" v-model="form.shipdays" oninput="value=value.replace(/[^\d]/g, '')"></el-input>
            </el-form-item>
            <el-form-item v-if="form.sale_type==1" label="预计发货时间" prop="sale_time" :rules="[{ required: true, message: '请输入商品预计发货时间', trigger: 'blur' }]">
              <el-col :span="20">
                <el-date-picker
                  v-model="form.sale_time"
                  type="datetime"
                  placeholder="选择日期时间">
                </el-date-picker>
              </el-col>
            </el-form-item>
        </el-card>
        <el-card header="选择预售商品" shadow="naver" v-if="!this.$route.params.id">
            <SkuSelector @change="getItems" :data="relItems"></SkuSelector>
        </el-card>
        <div class="content-center">
            <el-button type="primary" @click="submitActivityAction()">保存</el-button>
            <el-button @click.native="handleCancel">返回</el-button>
        </div>
    </el-form>
</template>
<script>
  import SkuSelector from '@/components/function/skuSelector'
  import {addGoodsPresale, editGoodsPresale, getGoodsPresaleInfo} from '../../../../api/promotions'
  export default {
    components: {
      SkuSelector
    },
    data() {
      return {
        relItems: [],
        sale_type: '0',
        form: {
          shipdays: '',
          items: [],
          sale_type: '0',
          sale_time: '',
        },
      }
    },
    methods: {
      submitActivityAction() {
        const that = this
        if (this.$route.params.id) {
          editGoodsPresale(this.$route.params.id, this.form).then(response => {
            this.loading = false
            this.$message({
              message: '修改成功',
              type: 'success',
              duration: 2 * 1000,
              onClose() {
                that.$router.go(-1)
              }
            })
          }).catch()
        } else {
          addGoodsPresale(this.form).then(response => {
            console.log(this.form)
            this.loading = false
            this.$message({
              message: '添加成功',
              type: 'success',
              duration: 2 * 1000,
              onClose() {
                that.$router.go(-1)
              }
            })
          }).catch()
        }
      },
      getItems(data) {
        let items = []
        data.forEach(item => {
          items.push(item.itemId)
        })
        this.form.items = items
      },
      getPresalePromotionsInfo(id) {
        getGoodsPresaleInfo(id).then(response => {
          this.form.id = response.data.data.id
          this.relItems = response.data.data.relItems
          this.form.shipdays = response.data.data.shipdays
          this.form.sale_type = response.data.data.sale_type
          this.form.sale_time = response.data.data.sale_time
        })
      },
      handleCancel() {
        this.$router.back(-1)
      },
      saleTypeChange (val) {
          this.form.sale_type = val
      },
    },
    mounted() {
      if (this.$route.params.id) {
        this.getPresalePromotionsInfo(this.$route.params.id)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// add.vue?841ad348